export const POSITION_ORDER = Object.freeze(['window', 'aisle']);
export const PASSENGER_COUNTS = Object.freeze([1, 2]);
